// extracted by mini-css-extract-plugin
export default {"msdLogo":"Navbar_msdLogo__pa7CO"};